import React from 'react';

const SKY = '#56B0FF';

/**
 * Which mark variant to show.
 * - 'colored'  : SKY centre bar, dark outer bars  (light header / auth page)
 * - 'light'    : all-white bars                   (dark / transparent header)
 * - 'dark'     : all-black bars                   (print / mono use)
 */
export type LogoVariant = 'colored' | 'light' | 'dark';

interface WorkWavLogoProps {
  size?: number;
  showText?: boolean;
  /** Colour for "work" portion of wordmark; "wav." always stays SKY */
  textColor?: string;
  fontSize?: number;
  /** Which mark file to load — pick based on background colour */
  variant?: LogoVariant;
}

const MARK_SRC: Record<LogoVariant, string> = {
  colored : '/assets/logo/workwav-mark.svg',
  light   : '/assets/logo/workwav-mark-mono-light.svg',
  dark    : '/assets/logo/workwav-mark-mono-dark.svg',
};

/**
 * WorkWav brand logo — official SVG mark asset + HTML wordmark.
 *
 * Use variant="light" on dark / transparent backgrounds (nav, hero).
 * Use variant="colored" (default) on white / light backgrounds.
 */
const WorkWavLogo: React.FC<WorkWavLogoProps> = ({
  size     = 36,
  showText = true,
  textColor = '#111111',
  fontSize  = 19,
  variant   = 'colored',
}) => {
  // Mark SVG has a 100×80 viewBox — height drives the display size
  // width is auto to preserve the 5:4 aspect ratio without distortion
  const markHeight = size;

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: Math.round(size * 0.22) }}>
      <img
        src={MARK_SRC[variant]}
        height={markHeight}
        width="auto"
        alt="WorkWav"
        draggable={false}
        style={{ flexShrink: 0, display: 'block', userSelect: 'none' }}
      />

      {showText && (
        <span style={{
          fontSize,
          fontWeight: 900,
          letterSpacing: -0.5,
          whiteSpace: 'nowrap',
          lineHeight: 1,
          fontFamily: 'inherit',
          userSelect: 'none',
        }}>
          <span style={{ color: textColor }}>work</span>
          <span style={{ color: SKY }}>wav.</span>
        </span>
      )}
    </div>
  );
};

export default WorkWavLogo;
